var React = require('react');

function FlagTurkey (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23 0H0.5V15H23V0Z","fill":"#E30A17","key":0}),React.createElement("path",{"d":"M8.46875 11.25C10.5398 11.25 12.2188 9.57107 12.2188 7.5C12.2188 5.42893 10.5398 3.75 8.46875 3.75C6.39768 3.75 4.71875 5.42893 4.71875 7.5C4.71875 9.57107 6.39768 11.25 8.46875 11.25Z","fill":"white","key":1}),React.createElement("path",{"d":"M9.40626 10.5C11.0631 10.5 12.4063 9.15686 12.4063 7.5C12.4063 5.84315 11.0631 4.5 9.40626 4.5C7.7494 4.5 6.40625 5.84315 6.40625 7.5C6.40625 9.15686 7.7494 10.5 9.40626 10.5Z","fill":"#E30A17","key":2}),React.createElement("path",{"d":"M11.4375 7.50027L14.8294 8.60237L12.7331 5.71704V9.2835L14.8294 6.39817L11.4375 7.50027Z","fill":"white","key":3})]);
}

FlagTurkey.defaultProps = {"width":"23","height":"15","viewBox":"0 0 23 15","fill":"none"};

module.exports = FlagTurkey;

FlagTurkey.default = FlagTurkey;
